export default "__VITE_ASSET__53510b33__"